import { Injectable, InjectionToken } from '@angular/core';
import { environment } from '../../environments/environment';

export const LOGGER_SERVICE = new InjectionToken<LoggerService>('LoggerService');

export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3
}

@Injectable({
  providedIn: 'root',
  useFactory: () => new LoggerService()
})
export class LoggerService {
  private readonly LOG_LEVEL = environment.production ? LogLevel.ERROR : LogLevel.DEBUG;
  private readonly LOG_PREFIX = '[Bayadic]';

  private formatMessage(level: string, message: string, meta?: any): string {
    const timestamp = new Date().toISOString();
    const metaStr = meta ? ` ${JSON.stringify(meta)}` : '';
    return `${timestamp} ${this.LOG_PREFIX} [${level}]: ${message}${metaStr}`;
  }

  private log(level: LogLevel, levelName: string, message: string, meta?: any) {
    if (level >= this.LOG_LEVEL) {
      const formattedMessage = this.formatMessage(levelName, message, meta);
      
      switch (level) {
        case LogLevel.DEBUG:
          console.debug(formattedMessage);
          break;
        case LogLevel.INFO:
          console.info(formattedMessage);
          break;
        case LogLevel.WARN:
          console.warn(formattedMessage);
          break;
        case LogLevel.ERROR:
          console.error(formattedMessage);
          break;
      }
    }
  }

  debug(message: string, meta?: any) {
    this.log(LogLevel.DEBUG, 'DEBUG', message, meta);
  }

  info(message: string, meta?: any) {
    this.log(LogLevel.INFO, 'INFO', message, meta);
  }

  warn(message: string, meta?: any) {
    this.log(LogLevel.WARN, 'WARN', message, meta);
  }

  error(message: string, meta?: any) {
    this.log(LogLevel.ERROR, 'ERROR', message, meta);
  }
} 